module.exports = __webpack_public_path__ + "img/Camera&lens2.4328ade6.png";